<template>
    <div class="shops">
        <TheHeader class="fixed pin-t w-full z-50" />
        <div class="site-content relative">
            <TheShopsNavigator />
        </div>
    </div>
</template>

<script>
import TheHeader from '@/js/components/TheHeader.vue';
import TheShopsNavigator from '@/js/components/TheShopsNavigator.vue';

export default {
    name: 'shops',
    components: {
        TheHeader,
        TheShopsNavigator
    }
};
</script>
